import { render } from "./CookiesAcceptModal.vue?vue&type=template&id=7f8a6a2d&ts=true"
import script from "./CookiesAcceptModal.vue?vue&type=script&lang=ts"
export * from "./CookiesAcceptModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTr});
